import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  Step,
  StepLabel,
  Stepper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import api from "_api";
import { GradientButtonOutline } from "components/GradientButton";
import TableModal from "components/TableExplanded/TableModal";
import { useEffect, useState } from "react";
import BANK_IMG from "assets/images/bangkok_bank.png";
import Dropzone from "components/Dropzone_one";
import { useAuth } from "hooks/useAuth";

const CustomizedDialogs = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    width: "100%",
    height: "auto",
    padding: theme.spacing(1),
    margin: theme.spacing(1),
    backgroundColor: theme.palette.background.default,
  },
}));

const formatPrice = (price) => {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
};

const ModalBuyPackage = ({ open, onClose, companyID }) => {
  const [step, setStep] = useState(0);
  const [packageList, setPackageList] = useState([]);
  const [historyList, setHistoryList] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [bankAccount, setBankAccount] = useState(null);
  const [files, setFiles] = useState([]);
  const [errorFiles, setErrorFiles] = useState(null);
  const [confirm, setConfirm] = useState(false);

  const fetchHistoryData = async () => {
    await api.super_admin
      .getCompanyMarketPlace(companyID)
      .then((res) => {
        if (res.isStatus && res.data) {
          setHistoryList(res.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching history data:", error);
      });
  };
  const fetchPackageData = async () => {
    await api.super_admin
      .getAllPackages()
      .then((res) => {
        if (res.isStatus && res.data) {
          let temp = res.data.filter((item) => item.status === true);
          setPackageList(temp);
        }
      })
      .catch((error) => {
        console.error("Error fetching package data:", error);
      });
  };

  const fetchBankAccount = async () => {
    await api.super_admin
      .getBill()
      .then((res) => {
        if (res.isStatus && res.data) {
          setBankAccount(res.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching bank account data:", error);
      });
  };
  useEffect(() => {
    fetchHistoryData();
    fetchPackageData();
    fetchBankAccount();
  }, []);

  useEffect(() => {
    handleClear();
  }, [open]);

  const handleClear = () => {
    setStep(0);
    setSelectedPackage(null);
    setFiles([]);
    setErrorFiles(null);
  };

  // Function to transform object to FormData
  const tranFormObjectToFormData = (obj) => {
    const formData = new FormData();

    Object.entries(obj).forEach(([key, value]) => {
      if (key === "company_type_id" && typeof value === "object" && value.id) {
        formData.append(key, value.id);
      } else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          if (typeof item === "object" && item !== null) {
            formData.append(`${key}[${index}]`, JSON.stringify(item));
          } else {
            formData.append(`${key}[${index}]`, item);
          }
        });
      } else if (key === "files" && Array.isArray(value)) {
        value.forEach((file, index) => {
          formData.append(`files[${index}]`, file);
        });
      } else {
        formData.append(key, value !== undefined ? value : ""); // Ensure undefined values are not passed
      }
    });

    // Log formData for debugging
    for (let pair of formData.entries()) {
      console.log(`${pair[0]}: ${pair[1]}`);
    }

    return formData;
  };

  const handleSubmit = async () => {
    const data = {
      marketplace_package_id: selectedPackage.marketplace_package_id,
      files: files.map((fileObj) => fileObj.file)[0],
    };
    const formData = tranFormObjectToFormData(data);
    await api.marketplace
      .postPurchasePackage(formData)
      .then((res) => {
        if (res.isStatus) {
          fetchHistoryData();
          handleClear();
          setConfirm(false);
          onClose();
        }
      })
      .catch((error) => {
        console.error("Error fetching package data:", error);
      });
  };

  const columns = [
    { Header: "ลำดับ", accessor: "index" },
    { Header: "แพ็คเกจ", accessor: "name_package" },
    { Header: "จำนวนคงเหลือ", accessor: "total_credit_remain" },
    {
      Header: "วันที่ที่ซื้อ",
      accessor: "start_date",
    },
  ];

  const stepList = ["เลือกแพ็คเกจที่ต้องการซื้อ", "ชำระเงิน"];

  const renderStep = () => {
    switch (step) {
      case 0:
        return (
          <>
            <TableModal data={historyList} columns={columns} />
          </>
        );
      case 1:
        return (
          <>
            <TableContainer>
              <Table
                sx={{
                  "& .MuiTableCell-root": {
                    padding: 0,
                    borderBottom: "none",
                  },
                }}
              >
                {packageList.map((pkg, index) => (
                  <TableCell key={index}>
                    <TableContainer>
                      <Table
                        sx={{
                          "& .MuiTableCell-root": {
                            padding: "16px",
                            borderBottom: "1px solid #E0E0E0",
                          },
                        }}
                      >
                        <TableBody>
                          <TableRow
                            sx={{
                              backgroundImage:
                                "linear-gradient(90deg, #00bb9f, #b0ee93)",
                              color: "#fff",
                            }}
                          >
                            <TableCell
                              align="center"
                              colSpan={2}
                              sx={{ fontWeight: "bold", color: "#fff" }}
                            >
                              <>
                                <Typography variant="h6">
                                  {pkg.name_package}
                                </Typography>
                                <Typography variant="body1">
                                  รายละเอียด
                                </Typography>
                              </>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="center" colSpan={2}>
                              {pkg.package_type === "normal"
                                ? "สินค้าอื่นๆ"
                                : "สินค้ายอดฮิต"}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="center" colSpan={2}>
                              {pkg.credit} เครดิต
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="center" colSpan={2}>
                              {pkg.total_day} วัน
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="center" colSpan={2}>
                              {pkg.price} บาท
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="center" colSpan={2}>
                              {
                                <Button
                                  className="button-two-tone"
                                  sx={{
                                    width: "auto",
                                    borderRadius: "12px",
                                    color: "#fff",
                                  }}
                                  onClick={() => {
                                    setSelectedPackage(pkg);
                                    setStep(2);
                                  }}
                                >
                                  เลือกแพ็คเกจ
                                </Button>
                              }
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </TableCell>
                ))}
              </Table>
            </TableContainer>
          </>
        );
      case 2:
        return (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                mt: 2,
              }}
            >
              <Typography variant="h5">ข้อมูลชำระเงิน</Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Typography>{selectedPackage?.name_package}</Typography>
                <Typography>
                  {formatPrice(selectedPackage?.price)} บาท
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Typography>Vat 7%</Typography>
                <Typography>
                  {formatPrice(selectedPackage?.price * 0.07)} บาท
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Typography>รวมทั้งหมด</Typography>
                <Typography>
                  {formatPrice(selectedPackage?.price * 1.07)} บาท
                </Typography>
              </Box>
              <Typography variant="h5">ช่องทางการชำระเงิน</Typography>
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  {bankAccount?.bank?.map((bank, index) => (
                    <Paper
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "16px",
                        borderRadius: "12px",
                        boxShadow: "4px",
                      }}
                      key={index}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "8px",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          component={"img"}
                          src={BANK_IMG}
                          sx={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "50%",
                          }}
                        />
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          <Typography>{bank?.bank_company}</Typography>
                          <Typography>เลขบัญชี {bank?.bank_number}</Typography>
                          <Typography>ชื่อบัญชี {bank?.bank_name}</Typography>
                        </Box>
                      </Box>
                    </Paper>
                  ))}
                  <Box>
                    <Typography sx={{ fontSize: "14px" }}>
                      หลังชำระแล้ว
                      กรุณาแนบรูปภาพหลักฐานการชำระเงินเพื่อเป็นหลักฐาน
                    </Typography>
                    <Typography sx={{ fontSize: "14px" }}>
                      เบอร์ติดต่อ{" "}
                      {bankAccount?.company?.length > 0 &&
                        bankAccount?.company[0]?.tel}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Dropzone
                    files={files}
                    setFiles={setFiles}
                    setError={setErrorFiles}
                  />
                  {errorFiles && (
                    <Typography sx={{ color: "red" }}>{errorFiles}</Typography>
                  )}
                </Grid>
              </Grid>
            </Box>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <CustomizedDialogs open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>
          <Typography variant="h4">
            {step === 0 ? "ประวัติการซื้อแพ็คเกจ" : "ซื้อแพ็คเกจ"}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <>
            {step !== 0 && (
              <Stepper
                activeStep={step - 1}
                sx={{
                  "& .MuiStepConnector-line": {
                    borderColor: "#E0E0E0",
                  },
                  "& .Mui-active": {
                    "& .MuiStepIcon-root": {
                      color: "#00bb9f",
                    },
                  },
                  "& .Mui-completed": {
                    "& .MuiStepIcon-root": {
                      color: "#757575",
                    },
                    "& .MuiStepLabel-label": {
                      color: "#757575",
                    },
                  },
                  mb: 2,
                }}
              >
                {stepList.map((label, index) => (
                  <Step key={index + 1}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            )}
            {renderStep()}
          </>
        </DialogContent>
        <DialogActions sx={{ mt: 2, borderTop: "1px solid #E0E0E0" }}>
          {step === 0 && (
            <>
              <GradientButtonOutline
                variant="outlined"
                sx={{ mr: 1 }}
                onClick={onClose}
              >
                ยกเลิก
              </GradientButtonOutline>
              <Button
                className="button-two-tone"
                variant="contained"
                onClick={() => setStep(1)}
                sx={{
                  width: "150px",
                  borderRadius: "12px",
                  height: "40px",
                  fontSize: "16px",
                }}
              >
                {" "}
                ซื้อแพ็คเกจ
              </Button>
            </>
          )}
          {step === 1 && (
            <>
              <GradientButtonOutline
                variant="outlined"
                sx={{ mr: 1 }}
                onClick={() => setStep(0)}
              >
                ย้อนกลับ
              </GradientButtonOutline>
            </>
          )}
          {step === 2 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <GradientButtonOutline
                variant="outlined"
                sx={{ mr: 1 }}
                onClick={() => setStep(1)}
              >
                กลับ
              </GradientButtonOutline>
              <Button
                className="button-two-tone"
                variant="contained"
                onClick={() => setConfirm(true)}
                sx={{
                  width: "auto",
                  borderRadius: "12px",
                }}
              >
                บันทึก
              </Button>
            </Box>
          )}
        </DialogActions>
      </CustomizedDialogs>
      <CustomizedDialogs open={confirm} onClose={() => setConfirm(false)}>
        <DialogTitle>
          <Typography variant="h5">กรุณารอการตรวจสอบยืนยัน</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>
            แอดมินจะทำการอนุมัติให้คุณ คุณต้องการยืนยันหรือไม่?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            sx={{
              width: "auto",
              borderRadius: "8px",
            }}
            onClick={() => setConfirm(false)}
          >
            ยกเลิก
          </Button>
          <Button
            className="button-two-tone"
            variant="contained"
            sx={{ width: "auto", borderRadius: "8px" }}
            onClick={() => handleSubmit()}
          >
            ยืนยัน
          </Button>
        </DialogActions>
      </CustomizedDialogs>
    </>
  );
};

export default ModalBuyPackage;
